webpackJsonp([1],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(307),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(305),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(311),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(304),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(298),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(299),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(310),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(308),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(302),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseHero__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseHero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BaseHero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BrandBlog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BasePanel__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BasePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BasePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_BaseHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VideoModal__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_VideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactForm__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ContactForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BrandServices__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BrandServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_BrandServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SearchResults__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_SearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_object_fit_images__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_wowjs__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_wowjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_wowjs__);





















__webpack_require__(196);
__webpack_require__(195).polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_smooth_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_16_object_fit_images___default()();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__components_App___default.a,
        Team: __WEBPACK_IMPORTED_MODULE_2__components_Team___default.a,
        BaseHero: __WEBPACK_IMPORTED_MODULE_3__components_BaseHero___default.a,
        BasePanel: __WEBPACK_IMPORTED_MODULE_5__components_BasePanel___default.a,
        BrandBlog: __WEBPACK_IMPORTED_MODULE_4__components_BrandBlog___default.a,
        BaseHeader: __WEBPACK_IMPORTED_MODULE_6__components_BaseHeader___default.a,
        VideoModal: __WEBPACK_IMPORTED_MODULE_7__components_VideoModal___default.a,
        ContactForm: __WEBPACK_IMPORTED_MODULE_8__components_ContactForm___default.a,
        BrandProfiles: __WEBPACK_IMPORTED_MODULE_12__components_BrandProfiles___default.a,
        BrandServices: __WEBPACK_IMPORTED_MODULE_9__components_BrandServices___default.a,
        BrandTimeline: __WEBPACK_IMPORTED_MODULE_10__components_BrandTimeline___default.a,
        BaseAccordian: __WEBPACK_IMPORTED_MODULE_11__components_BaseAccordian___default.a,
        SearchResults: __WEBPACK_IMPORTED_MODULE_13__components_SearchResults___default.a
    }
});

var wow = new __WEBPACK_IMPORTED_MODULE_17_wowjs___default.a.WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
    live: true,
    scrollContainer: null
});

wow.init();

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timingFunction; });
var duration = 250;
var timingFunction = 'ease-in-out';

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg4everybody__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg4everybody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg4everybody__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_svg4everybody___default()();
    }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseAccordian',
    props: {
        initialActiveIndex: {
            type: Number
        }
    },
    data: function data() {
        return {
            panels: [],
            activePanel: undefined
        };
    },

    methods: {
        navigate: function navigate(panel) {
            this.activePanel = panel;
        }
    },
    created: function created() {
        var _this = this;

        this.$on('add-panel', function (panel) {
            return _this.panels.push(panel);
        });
        this.$on('set-active-panel', function (panel) {
            _this.activePanel = panel;
        });
    },
    mounted: function mounted() {
        this.activePanel = this.initialActiveIndex === null ? null : this.panels[this.initialActiveIndex];
    }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseHeader',
    props: {
        site: {
            type: Object,
            required: true
        },
        menus: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            threshold: 0.1,
            windowWidth: 0,
            showMenu: false,
            showSearch: false,
            rootMargin: '170px',
            headerActive: false
        };
    },

    /* eslint-disable */
    methods: {
        enableScroll: function enableScroll() {
            document.ontouchmove = true;
        },
        preventScroll: function preventScroll() {
            document.ontouchmove = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
        },
        overflowTrigger: function overflowTrigger(state) {
            return document.documentElement.classList[state]('no-overflow');
        },
        toggleMenuState: function toggleMenuState(menu, showSearch, showMenu) {
            menu === '' + showSearch ? this[showMenu] = false : menu === '' + showMenu ? this[showSearch] = false : menu;
        },
        toggleMenus: function toggleMenus(menu) {
            this[menu] = !this[menu];

            if (this[menu]) {
                // this.preventScroll();
                if (document.documentElement.classList.contains('search--disabled')) {
                    this.showSearch = false;
                } else {
                    this.overflowTrigger('add');
                    this.toggleMenuState(menu, 'showSearch', 'showMenu');
                }
            } else {
                this.enableScroll();
                this.overflowTrigger('remove');
            }
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.header;
            });

            if (entry[0].intersectionRatio < this.threshold) {
                this.headerActive = true;
            } else {
                this.headerActive = false;
            }
        }
    },
    watch: {
        windowWidth: function windowWidth() {
            if (this.windowWidth > 1024) {
                this.showMenu = false;
                this.overflowTrigger('remove');
            }
        },
        showSearch: function showSearch() {
            if (this.showSearch) {
                this.$refs.input.autofocus = true;
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var io = new IntersectionObserver(this.intersect, {
            rootMargin: this.rootMargin,
            threshold: [this.threshold]
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.header);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseHero',
    data: function data() {
        return {
            activeItem: 0,
            showItem: true,
            windowWidth: 0,
            showContainer: false
        };
    },

    methods: {
        setActiveItem: function setActiveItem(itemIndex) {
            this.activeItem = itemIndex;
            this.showItem = false;
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.showContainer = true;
        }, 500);

        this.$nextTick(function () {
            window.addEventListener('resize', _this.getWindowWidth);
            _this.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BasePanel',
    components: {
        TransitionPanel: __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default.a
    },
    props: {
        active: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            isActive: undefined,
            accordion: undefined
        };
    },

    computed: {
        open: function open() {
            return this.accordion ? this === this.accordion.activePanel : this.isActive;
        }
    },
    methods: {
        toggle: function toggle() {
            if (this.accordion) {
                this.accordion.$emit('set-active-panel', this.open ? null : this);
            } else {
                this.isActive = !this.isActive;
            }
        }
    },
    created: function created() {
        var parent = this.$parent;

        while (parent) {
            if (parent.$options.name === 'BaseAccordian') {
                parent.$emit('add-panel', this);
                this.accordion = parent;
                this.isActive = null;

                return;
            }

            parent = parent.$parent;
        }

        this.accordion = null;
        this.isActive = this.active;
    }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BaseReveal',
    components: {
        TransitionPanel: __WEBPACK_IMPORTED_MODULE_0__components_TransitionPanel___default.a
    },
    props: {
        baseCopy: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            baseReveal: false
        };
    },

    methods: {
        toggleCopy: function toggleCopy() {
            this.baseReveal = !this.baseReveal;
        },
        spliceContent: function spliceContent(content) {
            var splicedContent = content.split('.')[0];
            return splicedContent + '.';
        },
        joinContent: function joinContent(content) {
            var joinedContent = content;
            return joinedContent.split('.').slice(1).join('.');
        }
    }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandBlog',
    props: {
        buttonText: {
            type: String,
            required: true
        },
        initialPosts: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            required: true
        },
        featuredPosts: {
            type: Array
        }
    },
    data: function data() {
        return {
            currentPage: 1,
            posts: this.initialPosts,
            currentCategory: undefined,
            previousCategory: undefined,
            hasLoadedMore: false,
            showLoadMore: true,
            isSticky: false
        };
    },

    computed: {
        categoryIDs: function categoryIDs() {
            var IDList = [];
            this.categories.forEach(function (category) {
                IDList.push(category.ID);
            });
            return IDList;
        }
    },
    /* eslint-disable */
    methods: {
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.featuredPost;
            });

            if (entry[0].intersectionRatio < 0.1) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        decode: function decode(str) {
            return __WEBPACK_IMPORTED_MODULE_1_he___default.a.decode(str);
        },
        getPostPreview: function getPostPreview(post) {
            var previewSources = [post && post.post_preview, post && post.acf && post.acf.post_preview];

            var preview = previewSources.find(function (value) {
                return typeof value === 'string' && value.trim().length > 0;
            });

            return preview || '';
        },
        spliceContent: function spliceContent(postContent) {
            if (typeof postContent === 'string' && postContent.trim().length > 0) {
                return postContent.split(' ').splice(0, 50).join(' ').concat('...');
            }

            return '';
        },
        getPosts: function getPosts(resetPageCount) {
            var _this2 = this;

            if (!this.hasLoadedMore) {
                this.hasLoadedMore = true;
            }

            if (resetPageCount === true) {
                this.currentPage = 1;
                this.showLoadMore = true;
            } else {
                this.currentPage += 1;
            }

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/wp-json/wp/v2/blog', {
                params: {
                    page: this.currentPage,
                    per_page: 12,
                    categories: this.currentCategory.toString(),
                    exclude_featured: true
                }
            }).then(function (response) {
                if (resetPageCount) {
                    _this2.posts = response.data;
                } else {
                    var _posts;

                    (_posts = _this2.posts).push.apply(_posts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
                }

                if (response.data.length < 12) {
                    _this2.showLoadMore = false;
                }
            }).catch(function (error) {
                _this2.showLoadMore = false;
            });
        },
        getCategoryNames: function getCategoryNames(categories) {
            var _this3 = this;

            if (categories) {
                var categoryNameList = [];
                categories.forEach(function (currentCategory) {
                    _this3.categories.forEach(function (category) {
                        if (currentCategory === category.ID) {
                            categoryNameList.push(_this3.decode(category.name));
                        }
                    });
                });

                return categoryNameList.join(', ');
            }

            return null;
        },
        convertDate: function convertDate(date) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYYMMDD').format('LL');
        },
        handleStickyPost: function handleStickyPost(container, articleHeight, headerHeight) {
            var desktopMediaQuery = window.matchMedia('(min-width: 640px)');

            Array.prototype.forEach.call(container, function (el, index) {
                var article = articleHeight[index];
                var isPrimaryContainer = index === 0;

                var updateStickyState = function updateStickyState() {
                    if (!desktopMediaQuery.matches) {
                        el.classList.remove('sticky');
                        el.classList.remove('postStatic');
                        return;
                    }

                    var containerElement = el.getBoundingClientRect();
                    var articleRect = article ? article.getBoundingClientRect() : null;
                    var containerReachedHeader = containerElement.top < headerHeight;
                    var reachedContainerBottom = articleRect && containerElement.height + containerElement.top - articleRect.height < headerHeight;

                    if (reachedContainerBottom) {
                        el.classList.remove('sticky');
                        el.classList.add('postStatic');
                    } else if (isPrimaryContainer || containerReachedHeader) {
                        el.classList.remove('postStatic');
                        el.classList.add('sticky');
                    } else {
                        el.classList.remove('sticky');
                        el.classList.remove('postStatic');
                    }
                };

                addEventListener('scroll', updateStickyState);
                addEventListener('resize', updateStickyState);
                updateStickyState();
            });
        }
    },
    created: function created() {
        this.currentCategory = this.categoryIDs;
        this.previousCategory = this.categoryIDs;
    },
    mounted: function mounted() {
        if (this.initialPosts.length < 12) {
            this.showLoadMore = false;
        };

        var headerHeight = 67;
        var postsContainer = document.querySelectorAll('.blog__posts-container');
        var articleContainer = document.querySelectorAll('.featured-article');

        this.handleStickyPost(postsContainer, articleContainer, headerHeight);
    }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandProfiles',
    props: {
        profiles: {
            type: Array,
            required: true
        },
        themeLink: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            windowWidth: 0,
            modalActive: false,
            showItem: null,
            nextActive: false,
            previousActive: false,
            currentProfile: undefined,
            currentProfileIndex: undefined
        };
    },

    /* eslint-disable */
    methods: {
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.profiles;
            });

            if (entry[0].intersectionRatio) {
                this.showItem = true;
                return;
            }

            this.showItem = false;
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        addComma: function addComma(str) {
            return str ? str.concat(',') : str;
        },
        spliceContent: function spliceContent(profileDescription) {
            var spliced = profileDescription;
            return spliced.split(' ').splice(0, 20).join(' ').concat('...');
        },
        toggleClass: function toggleClass(state, toggledClass) {
            return document.documentElement.classList[state](toggledClass);
        },
        scrollTo: function scrollTo(x) {
            return this.$refs.modal.scrollTop = x;
        },
        activateModal: function activateModal(profile) {
            this.showItem = false;
            this.currentProfile = profile;
            this.modalActive = !this.modalActive;

            if (this.modalActive) {
                this.toggleClass('add', 'no-overflow');
                this.toggleClass('add', 'brand-profiles--modal-active');
            } else {
                this.toggleClass('remove', 'no-overflow');
                this.toggleClass('remove', 'brand-profiles--modal-active');
            }
        },
        incrementProfile: function incrementProfile() {
            this.currentProfile = this.currentProfileIndex < this.profiles.length - 1 ? this.profiles[this.currentProfileIndex + 1] : this.profiles[this.profiles.length - 1];

            this.scrollTo(0);
        },
        decrementProfile: function decrementProfile() {
            this.currentProfile = this.currentProfileIndex > 0 ? this.profiles[this.currentProfileIndex - 1] : this.profiles[0];

            this.scrollTo(0);
        }
    },
    watch: {
        currentProfile: function currentProfile() {
            this.currentProfileIndex = this.profiles.indexOf(this.currentProfile);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var io = new IntersectionObserver(this.intersect, {
            threshold: [this.threshold],
            rootmargin: this.rootmargin
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.profiles);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandServices',
    props: {
        delay: {
            type: String,
            required: true
        },
        themeLink: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: false
        },
        familyServices: {
            type: Array,
            required: true
        },
        institutionServices: {
            type: Array,
            required: true
        },
        serviceType: {
            type: String
        }
    },
    data: function data() {
        return {
            activeCategory: null,
            lastActiveCategory: null,
            serviceTypesShown: 'all',
            activeServiceIndex: null,
            activeServiceCategory: null
        };
    },

    computed: {
        activeService: function activeService() {
            if (this.activeServiceIndex === null) {
                return null;
            }

            if (this.activeServiceCategory === 'institution') {
                return this.institutionServices[this.activeServiceIndex];
            }

            if (this.activeServiceCategory === 'family') {
                return this.familyServices[this.activeServiceIndex];
            }

            return null;
        }
    },
    methods: {
        depluralizer: function depluralizer(str) {
            return str.slice(str.length - 1) === 's' ? str.slice(0, str.length - 1) : str;
        },
        updateActiveService: function updateActiveService(serviceType) {
            this.activeServiceCategory = serviceType;
            if (this.activeService) {
                history.replaceState({}, document.title, '#' + this.activeService.slug);
            } else {
                history.replaceState({}, document.title, '#');
            }
        },
        handleClickEvent: function handleClickEvent(category, index) {
            this.activeServiceIndex = index;
            this.updateActiveService(category);
            this.activeCategory = null;
            this.scrollServiceContainerToTop();
        },
        scrollServiceContainerToTop: function scrollServiceContainerToTop() {
            if (this.$refs.serviceContainer) {
                this.$refs.serviceContainer.scrollTop = 0;
            }
        },
        toggleCategory: function toggleCategory(category) {
            this.activeCategory = this.activeCategory ? null : category;
        }
    },
    watch: {
        activeServiceCategory: function activeServiceCategory(newActiveServiceCategory) {
            if (newActiveServiceCategory !== null) {
                this.lastActiveCategory = newActiveServiceCategory;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.serviceType === 'family') {
            this.serviceTypesShown = 'family';
        }

        if (this.serviceType === 'institution') {
            this.serviceTypesShown = 'institution';
        }

        if (window.location.hash.substr(1)) {
            var requestedServiceSlug = window.location.hash.substr(1);

            this.familyServices.forEach(function (service) {
                if (requestedServiceSlug === service.slug) {
                    _this.activeServiceIndex = _this.familyServices.indexOf(service);
                    _this.activeServiceCategory = 'family';
                }
            });

            this.institutionServices.forEach(function (service) {
                if (requestedServiceSlug === service.slug) {
                    _this.activeServiceIndex = _this.institutionServices.indexOf(service);
                    _this.activeServiceCategory = 'institution';
                }
            });
        }

        addEventListener('click', function () {
            _this.activeCategory = null;
        });
    }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BrandTimeline',
    props: {
        events: {
            type: Array,
            required: true
        },
        breakpoint: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            threshold: 0.5,
            windowWidth: 0,
            intervalId: null,
            rootmargin: '-50px',
            activeEvent: null,
            timelineActive: false
        };
    },

    /* eslint-disable */
    computed: {
        eventsStyles: function eventsStyles() {
            if (this.windowWidth < this.breakpoint) {
                return {};
            }

            return {
                width: this.events.length * 440 + 'px',
                transform: 'translate(' + this.events.indexOf(this.activeEvent) * -440 + 'px, 0px)'
            };
        },
        eventsSorted: function eventsSorted() {
            return this.events.sort(this.sortByYear);
        }
    },
    methods: {
        nextEvent: function nextEvent() {
            var activeEventIndex = this.events.indexOf(this.activeEvent);

            if (this.timelineActive) {
                this.activeEvent = activeEventIndex < this.events.length - 1 ? this.events[activeEventIndex + 1] : this.activeEvent = this.events[0];
            }
        },
        intersect: function intersect(entries) {
            var _this = this;

            var entry = entries.filter(function (_ref) {
                var target = _ref.target;

                return target === _this.$refs.timeline;
            });

            if (entry[0].intersectionRatio > this.threshold && this.windowWidth > this.breakpoint) {
                this.timelineActive = true;
                this.intervalId = setInterval(this.nextEvent, 3000);
                return;
            }

            this.timelineActive = false;
            clearInterval(this.intervalId);
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        sortByYear: function sortByYear(a, b) {
            if (a.year < b.year) {
                return 1;
            }

            if (a.year > b.year) {
                return -1;
            }

            return 0;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.activeEvent = this.events[0];

        var io = new IntersectionObserver(this.intersect, {
            threshold: [0.5]
        });

        io.POLL_INTERVAL = 100;
        io.observe(this.$refs.timeline);

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contact-form',
    props: {
        options: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            success: null,
            notValid: null,
            submitting: false,
            submissionError: false,
            formFeilds: {
                email: undefined,
                message: undefined,
                lastName: undefined,
                firstName: undefined,
                phoneNumber: undefined
            }
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var token, formData, response;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.submitting) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (_this.$refs.form.checkValidity()) {
                                    _context.next = 5;
                                    break;
                                }

                                _this.notValid = true;
                                return _context.abrupt('return');

                            case 5:

                                _this.notValid = false;
                                _this.submissionError = false;
                                _this.submitting = true;

                                _context.prev = 8;
                                _context.next = 11;
                                return _this.getRecaptchaToken();

                            case 11:
                                token = _context.sent;


                                // Add the token directly to the outgoing request.
                                formData = new FormData(_this.$refs.form);

                                formData.set('g-recaptcha-response', token);

                                _context.next = 16;
                                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/wp-admin/admin-ajax.php', formData);

                            case 16:
                                response = _context.sent;

                                if (!(!response.data || response.data.success !== true)) {
                                    _context.next = 19;
                                    break;
                                }

                                throw new Error('Form submission failed');

                            case 19:

                                _this.resetForm('success', 'notValid');
                                _context.next = 26;
                                break;

                            case 22:
                                _context.prev = 22;
                                _context.t0 = _context['catch'](8);

                                _this.success = false;
                                _this.submissionError = true;

                            case 26:
                                _context.prev = 26;

                                _this.submitting = false;
                                return _context.finish(26);

                            case 29:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[8, 22, 26, 29]]);
            }))();
        },
        getRecaptchaToken: function getRecaptchaToken() {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (typeof window.grecaptcha === 'undefined') {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }

                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute('6Ld0sicsAAAAAIssHD-NHTWp6dkwKMH_CybkoPSC', { action: 'contact' }).then(function (token) {
                        return resolve(token);
                    }).catch(function (err) {
                        return reject(err);
                    });
                });
            });
        },
        resetForm: function resetForm(successful, unsuccessful) {
            var _this2 = this;

            this[successful] = true;
            this[unsuccessful] = false;

            if (this[successful]) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formFeilds).forEach(function (key) {
                    _this2.formFeilds[key] = '';
                });
            }
        }
    }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_he__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchResults',
    props: {
        query: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            results: [],
            page: 1,
            removeSearch: false,
            postsRemaining: false,
            searchResults: false
        };
    },

    methods: {
        decode: function decode(string) {
            return __WEBPACK_IMPORTED_MODULE_0_he___default.a.decode(string);
        },
        spliceContent: function spliceContent(searchContent) {
            var spliced = searchContent;
            return spliced.split(' ').splice(0, 20).join(' ').concat('...');
        },
        disableSearchIcon: function disableSearchIcon(state) {
            return document.documentElement.classList[state]('search--disabled');
        },
        getPosts: function getPosts() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/search/' + this.query, {
                params: {
                    page: this.page,
                    per_page: 5
                }
            }).then(function (response) {
                if (response.status === 200) {
                    _this.disableSearchIcon('add');
                    _this.results = _this.results.concat(response.data);
                } else {
                    _this.disableSearchIcon('remove');
                    _this.results = [0];
                }

                if (response.data.length > 5) {
                    _this.postsRemaining = true;
                } else {
                    _this.postsRemaining = false;
                }

                if (_this.query === '' && _this.query === undefined) {
                    _this.results = [0];
                }
            });

            this.page += 1;
        }
    },
    watch: {
        results: function results() {
            if (this.results.length === 0) {
                this.searchResults = true;
            } else {
                this.searchResults = false;
            }
        }
    },
    created: function created() {
        this.getPosts();
    }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BaseReveal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'team',
    components: {
        BaseReveal: __WEBPACK_IMPORTED_MODULE_0__components_BaseReveal___default.a
    },
    props: {
        teamMembers: {
            type: Array,
            required: true
        },
        optionText: {
            type: String,
            required: true
        },
        buttonTextPrimary: {
            type: String,
            required: true
        },
        buttonTextSecondary: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            windowWidth: 0,
            showItem: true,
            teamMemberIndex: 0,
            showTeamMember: false,
            activeTeamMember: undefined
        };
    },

    /* eslint-disable */
    computed: {
        filteredTeamMember: function filteredTeamMember() {
            var _this = this;

            var self = this;
            return this.teamMembers.filter(function (teamMember) {
                var foundTeamMember = teamMember.post_title.toLowerCase().indexOf(self.activeTeamMember.toLowerCase()) > -1;

                if (foundTeamMember) {
                    _this.teamMemberIndex = _this.teamMembers.indexOf(teamMember);
                }

                return foundTeamMember;
            });
        }
    },
    methods: {
        escapeHtml: function escapeHtml(value) {
            return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        },
        formatTrademark: function formatTrademark(value) {
            var normalized = String(value || '').replace(/&reg;|&#174;/gi, '®').replace(/&trade;|&#8482;/gi, '™');
            var escaped = this.escapeHtml(normalized);

            return escaped.replace(/([®™])/g, '<span class="team__trademark">$1</span>');
        },
        getWindowWidth: function getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        windowScroll: function windowScroll(teamMembers) {
            window.scrollTo(0, 170);
            return teamMembers;
        },
        activateTeamMember: function activateTeamMember(currentTeammember) {
            this.showItem = false;
            this.activeTeamMember = currentTeammember.post_title;
        },
        incrementTeamMember: function incrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex < this.teamMembers.length - 1 ? this.windowScroll(this.teamMembers[this.teamMemberIndex + 1].post_title) : this.teamMembers[this.teamMembers.length - 1].post_title;
        },
        decrementTeamMember: function decrementTeamMember() {
            this.activeTeamMember = this.teamMemberIndex > 0 ? this.windowScroll(this.teamMembers[this.teamMemberIndex - 1].post_title) : this.teamMembers[0].post_title;
        }
    },
    created: function created() {
        this.activeTeamMember = this.teamMembers[0].post_title;
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            window.addEventListener('resize', _this2.getWindowWidth);
            _this2.getWindowWidth();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__ = __webpack_require__(233);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'transition-slide',
    methods: {
        beforeEnter: function beforeEnter(el) {
            el.style.setProperty('will-change', 'height');
        },
        enter: function enter(el, complete) {
            __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, 'slideDown', { easing: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["a" /* timingFunction */], duration: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["b" /* duration */], complete: complete });
        },
        afterEnter: function afterEnter(el) {
            el.style.removeProperty('will-change');
        },
        beforeLeave: function beforeLeave(el) {
            el.style.setProperty('will-change', 'height');
        },
        leave: function leave(el, complete) {
            __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, 'slideUp', { duration: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["b" /* duration */], easing: __WEBPACK_IMPORTED_MODULE_1__js_util_transitions__["a" /* timingFunction */], complete: complete });
        },
        afterLeave: function afterLeave(el) {
            el.style.removeProperty('will-change');
        }
    }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VideoModal',
    props: {
        video_id: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            modalActive: false
        };
    }
});

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 56,
	"./af.js": 56,
	"./ar": 64,
	"./ar-dz": 57,
	"./ar-dz.js": 57,
	"./ar-kw": 58,
	"./ar-kw.js": 58,
	"./ar-ly": 59,
	"./ar-ly.js": 59,
	"./ar-ma": 60,
	"./ar-ma.js": 60,
	"./ar-ps": 61,
	"./ar-ps.js": 61,
	"./ar-sa": 62,
	"./ar-sa.js": 62,
	"./ar-tn": 63,
	"./ar-tn.js": 63,
	"./ar.js": 64,
	"./az": 65,
	"./az.js": 65,
	"./be": 66,
	"./be.js": 66,
	"./bg": 67,
	"./bg.js": 67,
	"./bm": 68,
	"./bm.js": 68,
	"./bn": 70,
	"./bn-bd": 69,
	"./bn-bd.js": 69,
	"./bn.js": 70,
	"./bo": 71,
	"./bo.js": 71,
	"./br": 72,
	"./br.js": 72,
	"./bs": 73,
	"./bs.js": 73,
	"./ca": 74,
	"./ca.js": 74,
	"./cs": 75,
	"./cs.js": 75,
	"./cv": 76,
	"./cv.js": 76,
	"./cy": 77,
	"./cy.js": 77,
	"./da": 78,
	"./da.js": 78,
	"./de": 81,
	"./de-at": 79,
	"./de-at.js": 79,
	"./de-ch": 80,
	"./de-ch.js": 80,
	"./de.js": 81,
	"./dv": 82,
	"./dv.js": 82,
	"./el": 83,
	"./el.js": 83,
	"./en-au": 84,
	"./en-au.js": 84,
	"./en-ca": 85,
	"./en-ca.js": 85,
	"./en-gb": 86,
	"./en-gb.js": 86,
	"./en-ie": 87,
	"./en-ie.js": 87,
	"./en-il": 88,
	"./en-il.js": 88,
	"./en-in": 89,
	"./en-in.js": 89,
	"./en-nz": 90,
	"./en-nz.js": 90,
	"./en-sg": 91,
	"./en-sg.js": 91,
	"./eo": 92,
	"./eo.js": 92,
	"./es": 96,
	"./es-do": 93,
	"./es-do.js": 93,
	"./es-mx": 94,
	"./es-mx.js": 94,
	"./es-us": 95,
	"./es-us.js": 95,
	"./es.js": 96,
	"./et": 97,
	"./et.js": 97,
	"./eu": 98,
	"./eu.js": 98,
	"./fa": 99,
	"./fa.js": 99,
	"./fi": 100,
	"./fi.js": 100,
	"./fil": 101,
	"./fil.js": 101,
	"./fo": 102,
	"./fo.js": 102,
	"./fr": 105,
	"./fr-ca": 103,
	"./fr-ca.js": 103,
	"./fr-ch": 104,
	"./fr-ch.js": 104,
	"./fr.js": 105,
	"./fy": 106,
	"./fy.js": 106,
	"./ga": 107,
	"./ga.js": 107,
	"./gd": 108,
	"./gd.js": 108,
	"./gl": 109,
	"./gl.js": 109,
	"./gom-deva": 110,
	"./gom-deva.js": 110,
	"./gom-latn": 111,
	"./gom-latn.js": 111,
	"./gu": 112,
	"./gu.js": 112,
	"./he": 113,
	"./he.js": 113,
	"./hi": 114,
	"./hi.js": 114,
	"./hr": 115,
	"./hr.js": 115,
	"./hu": 116,
	"./hu.js": 116,
	"./hy-am": 117,
	"./hy-am.js": 117,
	"./id": 118,
	"./id.js": 118,
	"./is": 119,
	"./is.js": 119,
	"./it": 121,
	"./it-ch": 120,
	"./it-ch.js": 120,
	"./it.js": 121,
	"./ja": 122,
	"./ja.js": 122,
	"./jv": 123,
	"./jv.js": 123,
	"./ka": 124,
	"./ka.js": 124,
	"./kk": 125,
	"./kk.js": 125,
	"./km": 126,
	"./km.js": 126,
	"./kn": 127,
	"./kn.js": 127,
	"./ko": 128,
	"./ko.js": 128,
	"./ku": 130,
	"./ku-kmr": 129,
	"./ku-kmr.js": 129,
	"./ku.js": 130,
	"./ky": 131,
	"./ky.js": 131,
	"./lb": 132,
	"./lb.js": 132,
	"./lo": 133,
	"./lo.js": 133,
	"./lt": 134,
	"./lt.js": 134,
	"./lv": 135,
	"./lv.js": 135,
	"./me": 136,
	"./me.js": 136,
	"./mi": 137,
	"./mi.js": 137,
	"./mk": 138,
	"./mk.js": 138,
	"./ml": 139,
	"./ml.js": 139,
	"./mn": 140,
	"./mn.js": 140,
	"./mr": 141,
	"./mr.js": 141,
	"./ms": 143,
	"./ms-my": 142,
	"./ms-my.js": 142,
	"./ms.js": 143,
	"./mt": 144,
	"./mt.js": 144,
	"./my": 145,
	"./my.js": 145,
	"./nb": 146,
	"./nb.js": 146,
	"./ne": 147,
	"./ne.js": 147,
	"./nl": 149,
	"./nl-be": 148,
	"./nl-be.js": 148,
	"./nl.js": 149,
	"./nn": 150,
	"./nn.js": 150,
	"./oc-lnc": 151,
	"./oc-lnc.js": 151,
	"./pa-in": 152,
	"./pa-in.js": 152,
	"./pl": 153,
	"./pl.js": 153,
	"./pt": 155,
	"./pt-br": 154,
	"./pt-br.js": 154,
	"./pt.js": 155,
	"./ro": 156,
	"./ro.js": 156,
	"./ru": 157,
	"./ru.js": 157,
	"./sd": 158,
	"./sd.js": 158,
	"./se": 159,
	"./se.js": 159,
	"./si": 160,
	"./si.js": 160,
	"./sk": 161,
	"./sk.js": 161,
	"./sl": 162,
	"./sl.js": 162,
	"./sq": 163,
	"./sq.js": 163,
	"./sr": 165,
	"./sr-cyrl": 164,
	"./sr-cyrl.js": 164,
	"./sr.js": 165,
	"./ss": 166,
	"./ss.js": 166,
	"./sv": 167,
	"./sv.js": 167,
	"./sw": 168,
	"./sw.js": 168,
	"./ta": 169,
	"./ta.js": 169,
	"./te": 170,
	"./te.js": 170,
	"./tet": 171,
	"./tet.js": 171,
	"./tg": 172,
	"./tg.js": 172,
	"./th": 173,
	"./th.js": 173,
	"./tk": 174,
	"./tk.js": 174,
	"./tl-ph": 175,
	"./tl-ph.js": 175,
	"./tlh": 176,
	"./tlh.js": 176,
	"./tr": 177,
	"./tr.js": 177,
	"./tzl": 178,
	"./tzl.js": 178,
	"./tzm": 180,
	"./tzm-latn": 179,
	"./tzm-latn.js": 179,
	"./tzm.js": 180,
	"./ug-cn": 181,
	"./ug-cn.js": 181,
	"./uk": 182,
	"./uk.js": 182,
	"./ur": 183,
	"./ur.js": 183,
	"./uz": 185,
	"./uz-latn": 184,
	"./uz-latn.js": 184,
	"./uz.js": 185,
	"./vi": 186,
	"./vi.js": 186,
	"./x-pseudo": 187,
	"./x-pseudo.js": 187,
	"./yo": 188,
	"./yo.js": 188,
	"./zh-cn": 189,
	"./zh-cn.js": 189,
	"./zh-hk": 190,
	"./zh-hk.js": 190,
	"./zh-mo": 191,
	"./zh-mo.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._t("default", null, {
    "showItem": _vm.showItem,
    "activeItem": _vm.activeItem,
    "windowWidth": _vm.windowWidth,
    "showContainer": _vm.showContainer,
    "setActiveItem": _vm.setActiveItem
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      panel_active: _vm.open
    }
  }, [_c('div', {
    staticClass: "brand-strengths__button-wrapper"
  }, [_c('hr', {
    staticClass: "brand-strengths__horizontal-rule"
  }), _vm._v(" "), _c('button', {
    staticClass: "brand-strengths__button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("heading"), _vm._v(" "), _c('div', {
    staticClass: "brand_strengths_toggle-container"
  }, [_vm._t("toggle_symbol")], 2)], 2), _vm._v(" "), _c('transition-panel', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, [_c('div', {
    staticClass: "brand-strengths__item-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "video-modal__button",
    on: {
      "click": function($event) {
        _vm.modalActive = true
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalActive) ? _c('div', {
    staticClass: "video-modal__modal"
  }, [_c('button', {
    staticClass: "video-modal__close",
    on: {
      "click": function($event) {
        _vm.modalActive = false
      }
    }
  }, [_c('svg', {
    staticClass: "video-modal__close-image",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.967 66.236"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none",
      "stroke": "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "26.418",
      "x2": "44.283",
      "y2": "40.918",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "40.918",
      "x2": "44.283",
      "y2": "26.418",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  })])]), _vm._v(" "), _c('youtube', {
    staticClass: "video-modal__video",
    attrs: {
      "video-id": _vm.video_id,
      "player-vars": {
        autoplay: 1,
        modestbranding: 1,
        showinfo: 0,
        playsinline: 1,
        rel: 0
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "search__results"
  }, [_c('div', {
    staticClass: "search__results-container"
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": _vm.query
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search__results-signifier"
  }, [_vm._v("Search Results:")]), _vm._v(" "), _vm._l((_vm.results), function(result) {
    return _c('article', {
      staticClass: "search__result"
    }, [_c('a', {
      staticClass: "search__result-title",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(result.title.rendered))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "search__result-content",
      domProps: {
        "innerHTML": _vm._s(_vm.spliceContent(result.content.rendered))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "search__result-link",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "search-result__hr"
    })])
  }), _vm._v(" "), (_vm.postsRemaining) ? _c('button', {
    staticClass: "search-results__load-more",
    domProps: {
      "textContent": _vm._s('Load More')
    },
    on: {
      "click": _vm.getPosts
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticClass: "search__result-none",
    domProps: {
      "textContent": _vm._s('No search results.')
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "form",
    staticClass: "contact-form__input-container",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "action",
      "value": "contact"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__input-section"
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "first-name"
    },
    domProps: {
      "textContent": _vm._s('First Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.firstName),
      expression: "formFeilds.firstName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small--primary",
    attrs: {
      "name": "first-name",
      "id": "first-name",
      "type": "text",
      "placeholder": "First Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "last-name"
    },
    domProps: {
      "textContent": _vm._s('Last Name')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.lastName),
      expression: "formFeilds.lastName"
    }],
    staticClass: "contact-form__input contact-form__input_small contact-form__input_small contact-form__input_small--secondary",
    attrs: {
      "id": "last-name",
      "name": "last-name",
      "type": "text",
      "placeholder": "Last Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "phone-number"
    },
    domProps: {
      "textContent": _vm._s('Phone Number')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.phoneNumber),
      expression: "formFeilds.phoneNumber"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "phone-number",
      "name": "phone-number",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.formFeilds.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "email"
    },
    domProps: {
      "textContent": _vm._s('Email')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.email),
      expression: "formFeilds.email"
    }],
    staticClass: "contact-form__input contact-form__input_big",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": "Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.formFeilds.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "message"
    },
    domProps: {
      "textContent": _vm._s('Message')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formFeilds.message),
      expression: "formFeilds.message"
    }],
    staticClass: "contact-form__input contact-form__input_big contact-form__input__big-bottom",
    attrs: {
      "id": "message",
      "name": "message",
      "type": "text",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.formFeilds.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formFeilds, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-form__button-container"
  }, [(_vm.notValid || _vm.submissionError) ? _c('p', {
    staticClass: "paragraph-01 contact-form__validity-copy",
    domProps: {
      "textContent": _vm._s(_vm.options.form_error)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('button', {
    staticClass: "contact-form__submit-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.submitting,
      "aria-pressed": "false",
      "aria-describedby": "submit-button"
    }
  }, [_c('span', {
    staticClass: "contact-form__submit-btn-text"
  }, [_vm._v(_vm._s(_vm.options.submit_button_text))])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "contact-form__submitted-container"
  }, [_c('h3', {
    staticClass: "paragraph-01",
    domProps: {
      "textContent": _vm._s(_vm.options.form_submit)
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "team",
    staticClass: "team"
  }, [_c('transition-group', {
    staticClass: "team__members-photo-container-desktop",
    attrs: {
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.xxxlarge,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w,' + teamMember.image.sizes.xxxlarge + ' 3000w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "team__inner wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_c('header', {
    staticClass: "team__heading-content"
  }, [_vm._t("team-heading-mobile"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTeamMember),
      expression: "activeTeamMember"
    }],
    staticClass: "select-dark team__members",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeTeamMember = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "aria-label": "select"
    },
    domProps: {
      "textContent": _vm._s(_vm.optionText)
    }
  }), _vm._v(" "), _vm._l((_vm.teamMembers), function(teamMember) {
    return _c('option', {
      key: teamMember.ID,
      domProps: {
        "textContent": _vm._s(teamMember.post_title)
      }
    })
  })], 2)], 2), _vm._v(" "), _c('transition-group', {
    staticClass: "team__members-photo-container",
    attrs: {
      "tag": "div",
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.large,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "team__member-container_left",
    class: _vm.showItem ? 'fade-primary' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_vm._t("team-heading-desktop"), _vm._v(" "), _c('ul', {
    staticClass: "team__member-list"
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return _c('li', {
      key: index,
      staticClass: "team__member-item",
      on: {
        "click": function($event) {
          return _vm.activateTeamMember(teamMember)
        }
      }
    }, [_c('button', {
      staticClass: "team__member-item-btn",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTrademark(teamMember.post_title))
      }
    })])
  }), 0)], 2), _vm._v(" "), _vm._l((_vm.filteredTeamMember), function(teamMember) {
    return _c('div', {
      key: teamMember.ID,
      staticClass: "team__member-container_right"
    }, [_c('article', {
      staticClass: "team__member-description-container",
      class: _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": "0.5s"
      }
    }, [_c('h3', {
      staticClass: "team__member-name",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTrademark(teamMember.post_title))
      }
    }), _vm._v(" "), _vm._t("svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-copy team__member-copy--mobile",
      domProps: {
        "textContent": _vm._s(teamMember.copy)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "team__member-nav-container"
    }, [_c('button', {
      staticClass: "team__member-previous-button",
      class: _vm.teamMemberIndex === 0 ? 'team__member-previous-button--disabled' : null,
      on: {
        "click": function($event) {
          return _vm.decrementTeamMember()
        }
      }
    }, [_vm._t("carrot-svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Previous')
      }
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "team__member-next-button",
      class: _vm.teamMemberIndex === _vm.teamMembers.length - 1 ? 'team__member-next-button--disabled' : null,
      on: {
        "click": function($event) {
          return _vm.incrementTeamMember()
        }
      }
    }, [_c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Next')
      }
    }), _vm._v(" "), _vm._t("carrot-svg-rotated")], 2)]), _vm._v(" "), (_vm.windowWidth >= 1024) ? _c("base-reveal", {
      tag: "div",
      attrs: {
        "base-copy": teamMember.copy
      }
    }) : _vm._e()], 2)])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "header",
    staticClass: "header",
    class: [
      _vm.headerActive ? 'header--active' : null,
      _vm.showSearch ? 'header--search-active' : null,
      _vm.showMenu ? 'header--hamburger-active' : null ]
  }, [_c('div', {
    staticClass: "header__container-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__secondary-link-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]), _vm._v(" "), (_vm.headerActive) ? _c('div', {
    staticClass: "header__container-secondary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg-horizontal")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon-secondary"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-container"
  }, [_c('form', {
    staticClass: "header__modal-search-container",
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    },
    domProps: {
      "textContent": _vm._s('Search')
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "required": ""
    }
  })])])]), _vm._v(" "), (_vm.showMenu) ? _c('nav', {
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-menu-container"
  }, [_c('div', {
    staticClass: "header__modal-menu-inner"
  }, [_c('ul', {
    staticClass: "header__modal-list"
  }, _vm._l((_vm.menus.header_primary.items), function(item) {
    return (_vm.menus.header_primary.items) ? _c('li', {
      staticClass: "header__modal-item"
    }, [_c('a', {
      staticClass: "label-heading-01 header__modal-link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('hr', {
    staticClass: "horizontal-rule-03"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__modal-sublink-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__modal-sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), 0)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog"
  }, [_c('section', {
    staticClass: "blog__posts-container blog__posts-container--primary"
  }, [_c('section', {
    staticClass: "blog__posts"
  }, _vm._l((_vm.posts.slice(0, 5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getPostPreview(post)) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(_vm.getPostPreview(post)))
      }
    }) : _vm._e(), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      }
    }, [_vm._v("\n                    Read More\n                ")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    ref: "featuredPost",
    staticClass: "blog__post blog__post--featured",
    attrs: {
      "data-wow-delay": "0.25s"
    }
  }, [_vm._t("featured-post--primary")], 2)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('section', {
    staticClass: "blog__posts-container blog__posts-container--secondary"
  }, [_c('section', {
    staticClass: "blog__posts blog__posts--secondary"
  }, _vm._l((_vm.posts.slice(5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date))
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date))
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getPostPreview(post)) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(_vm.getPostPreview(post)))
      }
    }) : _vm._e(), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "blog__post blog__post-featured_secondary"
  }, [_vm._t("featured-post--secondary")], 2)]), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "blog__load-more-container"
  }, [_c('button', {
    staticClass: "blog__load-more",
    domProps: {
      "textContent": _vm._s(_vm.buttonText)
    },
    on: {
      "click": function($event) {
        return _vm.getPosts(false)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "services",
    class: [
      _vm.activeServiceCategory !== null && _vm.activeServiceIndex !== null ? ("services--" + _vm.activeServiceCategory) : null,
      _vm.lastActiveCategory ? (_vm.lastActiveCategory + "-last-active") : null
    ]
  }, [_c('div', {
    staticClass: "services__category-containers"
  }, [_c('div', {
    staticClass: "services__category-container service__category-container--family"
  }, [_vm._t("family_category_background_image"), _vm._v(" "), _c('div', {
    staticClass: "services__category-overlay services__category-overlay--family"
  }), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family') ? _c('h1', {
    staticClass: "services__category-title wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    domProps: {
      "textContent": _vm._s('Families')
    }
  }) : _vm._e(), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family') ? _c('div', {
    staticClass: "services__subheading-container"
  }, [_vm._t("brand-services-families-subheading"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeServiceIndex),
      expression: "activeServiceIndex"
    }],
    staticClass: "services__category-select-container select-dark wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeServiceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateActiveService('family')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.familyServices), function(service, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index,
        "textContent": _vm._s(service.post_title)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-button-container select-dark wow fadeInUp"
  }, [_c('button', {
    staticClass: "services__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.activeService ? _vm.activeService.post_title : '&nbsp;')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleCategory('family')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services__category-spacer"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.activeCategory === 'family') ? _c('div', _vm._l((_vm.familyServices), function(service, index) {
    return _c('button', {
      key: index,
      staticClass: "services__category-button",
      domProps: {
        "textContent": _vm._s(service.post_title)
      },
      on: {
        "click": function($event) {
          return _vm.handleClickEvent('family', index)
        }
      }
    })
  }), 0) : _vm._e()])], 1)], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-container service__category-container--institution"
  }, [_vm._t("institution_category_background_image"), _vm._v(" "), _c('div', {
    staticClass: "services__category-overlay services__category-overlay--institution"
  }), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution') ? _c('h1', {
    staticClass: "services__category-title wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    domProps: {
      "textContent": _vm._s('Institutions')
    }
  }) : _vm._e(), _vm._v(" "), (this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution') ? _c('div', {
    staticClass: "services__subheading-container"
  }, [_vm._t("brand-services-institutions-subheading"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeServiceIndex),
      expression: "activeServiceIndex"
    }],
    staticClass: "services__category-select-container select-light wow fadeInUp",
    attrs: {
      "data-wow-delay": _vm.delay
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeServiceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateActiveService('institution')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.institutionServices), function(service, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "textContent": _vm._s(service.post_title)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "services__category-button-container select-light wow fadeInUp"
  }, [_c('button', {
    staticClass: "services__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.activeService ? _vm.activeService.post_title : '&nbsp;')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleCategory('institution')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services__category-spacer"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.activeCategory === 'institution') ? _c('div', _vm._l((_vm.institutionServices), function(service, index) {
    return _c('button', {
      key: index,
      staticClass: "services__category-button",
      domProps: {
        "textContent": _vm._s(service.post_title)
      },
      on: {
        "click": function($event) {
          return _vm.handleClickEvent('institution', index)
        }
      }
    })
  }), 0) : _vm._e()])], 1)], 2) : _vm._e()], 2)]), _vm._v(" "), _c('article', {
    staticClass: "service",
    class: _vm.activeService ? 'service--active' : null
  }, [_c('button', {
    staticClass: "service__modal-close",
    on: {
      "click": function($event) {
        _vm.activeServiceIndex = null
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 23.213 23.213",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/modal-close.svg#modal-close'
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "serviceContainer",
    staticClass: "service__container"
  }, [_c('div', [(_vm.activeService) ? _c('h3', {
    staticClass: "service__subheading",
    domProps: {
      "textContent": _vm._s(_vm.activeService.post_title)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.activeService) ? _c('div', {
    staticClass: "service__heading",
    domProps: {
      "textContent": _vm._s(_vm.activeService.header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('div', {
    staticClass: "service__content",
    domProps: {
      "textContent": _vm._s(_vm.activeService.copy)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('h2', {
    staticClass: "service__heading service__heading--small",
    domProps: {
      "textContent": _vm._s(_vm.options.contact_header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('p', {
    staticClass: "service__content",
    domProps: {
      "textContent": _vm._s(_vm.options.contact_copy)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeService) ? _c('a', {
    staticClass: "service__link",
    attrs: {
      "href": _vm.options.contact_link
    },
    domProps: {
      "textContent": _vm._s(_vm.options.contact_link_text)
    }
  }) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "timeline",
    staticClass: "timeline",
    class: _vm.windowWidth <= 768 ? 'wow fadeIn' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('header', {
    staticClass: "timeline__intro",
    class: _vm.windowWidth > 768 ? 'wow fadeInRight' : null,
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "timeline__heading-container"
  }, [_vm._t("heading")], 2), _vm._v(" "), _c('div', {
    staticClass: "timeline__copy-container"
  }, [_vm._t("copy")], 2)]), _vm._v(" "), (_vm.events) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeEvent),
      expression: "activeEvent"
    }],
    staticClass: "timeline__year-list",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('option', {
      key: index,
      staticClass: "timeline__year-item",
      class: event === _vm.activeEvent ? 'timeline__year-item--active' : null,
      domProps: {
        "value": event,
        "textContent": _vm._s(event.year)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "timeline__year-line-list",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, _vm._l((_vm.eventsSorted), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__year-line-item",
      class: event === _vm.activeEvent ? 'timeline__year-line-item--active' : null
    }, [_c('button', {
      staticClass: "timeline__year-line-button",
      domProps: {
        "textContent": _vm._s(event.year)
      },
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    })])
  }), 0), _vm._v(" "), _c('section', {
    staticClass: "timeline__events-container",
    on: {
      "click": function($event) {
        _vm.timelineActive = false
      }
    }
  }, [_c('div', [_c('ul', {
    staticClass: "timeline__events",
    style: (_vm.eventsStyles)
  }, _vm._l((_vm.events), function(event, index) {
    return _c('li', {
      key: index,
      staticClass: "timeline__event",
      class: event === _vm.activeEvent ? 'timeline__event--active' : null,
      on: {
        "click": function($event) {
          _vm.activeEvent = event
        }
      }
    }, [_c('article', {
      staticClass: "timeline__event-content"
    }, [_c('h2', {
      staticClass: "timeline__event-year",
      domProps: {
        "textContent": _vm._s(event.year)
      }
    }), _vm._v(" "), _c('h5', {
      staticClass: "timeline__event-heading",
      domProps: {
        "textContent": _vm._s(event.heading)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "timeline__event-description",
      domProps: {
        "textContent": _vm._s(event.description)
      }
    })])])
  }), 0), _vm._v(" "), _c('article', {
    staticClass: "timeline__events-reveal"
  }, [_c('div', {
    staticClass: "timeline__events-reveal-container"
  }, [_vm._t("reveal-heading"), _vm._v(" "), _vm._t("reveal-copy"), _vm._v(" "), _vm._t("reveal-button")], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "profiles",
    staticClass: "profiles",
    attrs: {
      "id": "brand-profiles"
    }
  }, [_c('div', {
    staticClass: "profiles__container",
    class: _vm.windowWidth <= 768 ? 'wow fadeInUp' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, _vm._l((_vm.profiles), function(profile, index) {
    return _c('div', {
      key: profile.ID,
      staticClass: "profile",
      class: _vm.windowWidth > 768 && _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": _vm.windowWidth > 768 && _vm.showItem ? index * 0.25 + 's' : null
      }
    }, [_c('div', {
      staticClass: "profile__image-container"
    }, [_c('img', {
      staticClass: "profile__image",
      attrs: {
        "src": profile.image.url,
        "alt": profile.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "profile__headings"
    }, [_c('h5', {
      staticClass: "label-subheading profile__date"
    }, [_vm._v("Winner")]), _vm._v(" "), (profile.post_title) ? _c('h4', {
      staticClass: "heading-05 profile__name",
      domProps: {
        "textContent": _vm._s(profile.post_title)
      }
    }) : _vm._e()]), _vm._v(" "), (profile.description) ? _c('p', {
      staticClass: "paragraph-02 profile__copy",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(profile.description))
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "paragraph-01 profile__modal-open",
      domProps: {
        "textContent": _vm._s('Learn More')
      },
      on: {
        "click": function($event) {
          return _vm.activateModal(profile)
        }
      }
    })])
  }), 0), _vm._v(" "), (_vm.modalActive) ? _c('article', {
    ref: "modal",
    staticClass: "base-modal"
  }, [_c('div', {
    staticClass: "profiles__modal"
  }, [_c('button', {
    staticClass: "profile__modal-close",
    on: {
      "click": function($event) {
        return _vm.activateModal()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 23.213 23.213",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/modal-close.svg#modal-close'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_headings"
  }, [_c('h4', {
    staticClass: "heading-02 profile__modal-name",
    domProps: {
      "textContent": _vm._s(_vm.currentProfile.post_title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph-01 profile__modal-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.addComma(_vm.currentProfile.award_winners_title)) + "\n                    "), _c('span', {
    staticClass: "paragraph-01 profile__modal-organization"
  }, [_vm._v(_vm._s(_vm.currentProfile.organization))])])]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal_image-container"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProfile.image.url),
      expression: "currentProfile.image.url"
    }],
    staticClass: "profile__image",
    attrs: {
      "src": _vm.currentProfile.image.url,
      "alt": _vm.currentProfile.image.alt === '' ? 'Photo of ' + _vm.currentProfile.post_title : _vm.currentProfile.image.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-copy_container"
  }, [_c('div', {
    staticClass: "paragraph-02 profile__modal_copy",
    domProps: {
      "innerHTML": _vm._s(_vm.currentProfile.description_formatted)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__modal-navigation-container"
  }, [_c('button', {
    staticClass: "profile__modal-previous-button",
    class: _vm.currentProfileIndex === 0 ? 'profile__modal-next-button--disabled' : null,
    on: {
      "click": function($event) {
        return _vm.decrementProfile()
      }
    }
  }, [_c('svg', {
    staticClass: "profile__modal-svg",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "profile__modal-navigation-copy",
    domProps: {
      "textContent": _vm._s('Previous')
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "profile__modal-next-button",
    class: _vm.currentProfileIndex === _vm.profiles.length - 1 ? 'profile__modal-previous-button--disabled' : null,
    on: {
      "click": function($event) {
        return _vm.incrementProfile()
      }
    }
  }, [_c('p', {
    staticClass: "profile__modal-navigation-copy profile__modal-navigation-secondary",
    domProps: {
      "textContent": _vm._s('Next')
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "profile__modal-svg profile__modal-svg--rotated",
    attrs: {
      "viewBox": "0 0 8.824 15.147",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.themeLink + '/dist/static/graphics/carrot.svg#carrot'
    }
  })])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team__member-reveal"
  }, [_c('p', {
    staticClass: "team__member-copy team__member-copy--desktop",
    domProps: {
      "textContent": _vm._s(_vm.spliceContent(_vm.baseCopy))
    }
  }), _vm._v(" "), (!_vm.baseReveal) ? _c('button', {
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextPrimary)
    },
    on: {
      "click": function($event) {
        return _vm.toggleCopy()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "team__copy-container"
  }, [_c('transition-panel', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "paragraph-01 team__member-copy",
    domProps: {
      "textContent": _vm._s(_vm.joinContent(_vm.baseCopy))
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextSecondary)
    },
    on: {
      "click": function($event) {
        return _vm.toggleCopy()
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ })

},[232]);


// WEBPACK FOOTER //
// static/js/app.16ed75b73153ceeb300a.js